import { UserAchievementsType } from '@sportspredict/shared';
import { ACHIEVEMENT_COPY, REFERRAL_ACHIEVEMENT_TYPES } from '@/constants';

interface Achievement {
	type: UserAchievementsType;
	details?: {
		eventName?: string;
		slateName?: string;
	};
}

export function getAchievementTitle(achievement: Achievement): string {
	const meta = ACHIEVEMENT_COPY[achievement.type] ?? {};

	const profileTitle = 'profileTitle' in meta ? meta.profileTitle : undefined;

	if (REFERRAL_ACHIEVEMENT_TYPES.includes(achievement.type)) {
		return profileTitle ?? meta.title ?? '';
	}

	if (achievement.type === UserAchievementsType.SlateWinner && achievement.details) {
		const slateName = achievement.details.slateName ?? '';

		return `Perfect Trades in ${achievement.details.eventName}${slateName ? `, ${slateName}` : ''}`;
	}

	return profileTitle ?? meta.title ?? '';
}
